<template>
  <div class="newsMore">
    <div class="top_title">
      <img src="../../assets/image/maxHomeLogo.png" alt />
    </div>
    <div class="content">
      <div class="content_title">
        <p>{{ title }}</p>
        <p>日期：{{ time }}</p>
      </div>
      <div v-html="content" style="margin-top: 49px;padding: 0 21px;"></div>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import MyFooter from "../Footer";
export default {
  components: {
    MyFooter,
  },
  data() {
    return {
      title: "",
      content: "",
      time: "",
    };
  },
  mounted() {
    let MoreId = this.$route.query.moreId;
    if (MoreId) {
      this.getEventMoreInfo(MoreId);
    }
  },
  methods: {
    getEventMoreInfo(id) {
      this.$http({
        url: "promotion/getPromotionInfo",
        method: "post",
        params: {
          id: id,
        },
      }).then(({ data }) => {
        let { code, promotion } = data;
        if (code === 0) {
          this.content = promotion.content.replace(
            /<img/g,
            "<img style='max-width: 100%;height: auto; crossOrigin; display: block; margin: 0 auto;' "
          );
          this.title = promotion.title;
          this.time = promotion.uploadDate.substring(0, 10);
        } else {
          console.log(data.msg);
        }
      }).catch(err => console.log(err))
    },
  },
};
</script>
<style lang="scss" scoped>
.newsMore {
  min-width: 1200px;
  .top_title {
    height: 186px;
    border-bottom: 2px solid #d5d5d5;
    text-align: center;
    img {
      margin-top: 36px;
    }
  }
  .content {
    min-height: 1362px;
    width: 1200px;
    margin: 0 auto 60px;
    .content_title {
      height: 199px;
      border-bottom: 1px solid #d5d5d5;
      text-align: center;
      font-size: 28px;
      padding-top: 1px;
      p:first-child {
        line-height: 48px;
        width: 830px;
        height: 96px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin: 55px auto 20px;
      }
      p:last-child {
        text-align: right;
        font-size: 17px;
        color: #999999;
      }
    }
  }
}
</style>